import { ref, watch, computed } from 'vue';

const usePagination = (props, totalItems) => {
  const itemsPerPage = ref(props.itemsPerPage);
  const activePageOffset = ref(0);
  watch(
    () => props.itemsPerPage,
    () => {
      itemsPerPage.value = props.itemsPerPage;
      activePageOffset.value = 0;
    }
  );
  const totalPages = computed(() => totalItems.value && totalItems.value > 0 ? Math.ceil(totalItems.value / itemsPerPage.value) : 0);
  const hasPagination = computed(() => totalPages.value > 1);
  const onClickPagination = (page) => {
    activePageOffset.value = page;
  };
  return {
    itemsPerPage,
    activePageOffset,
    totalItems,
    totalPages,
    hasPagination,
    onClickPagination
  };
};

export { usePagination };
